import { Box, Text } from '@bechtel/gds';
import { useAppUser } from '@bechtel/ht-clients-common';
import { FC, useState } from 'react';
import { ErrorBoundary } from '~/components';
import { UnderConstruction } from '~/components/under-construction';
import { ProjectAdminSubContainerStyled } from '../user-admin/styled';
import { ProjectConfigurationDetails } from './details';
import { ProjectConfigurationList } from './list';
import { ProjectAdminContainer, ProjectConfigurationTitle } from './styled';

export const ProjectAdmin: FC = () => {
  const [configurationDetails, setConfigurationDetails] = useState(null);
  const { appUser } = useAppUser();
  const canUpdateConfiguration =
    appUser?.bun.toLocaleUpperCase() == 'AKUMAR63' ||
    appUser?.bun.toLocaleUpperCase() == 'SGROVER' ||
    appUser?.bun.toLocaleUpperCase() == 'JRHARTER';
  return (
    <ProjectAdminContainer>
      <ProjectConfigurationTitle>
        <Text family="openSansSemiBold" weight="600" size="500" color="neutral.800">
          {canUpdateConfiguration ? 'Project Configuration' : 'Project Admin'}
        </Text>
      </ProjectConfigurationTitle>
      {canUpdateConfiguration ? (
        <ErrorBoundary>
          <ProjectAdminSubContainerStyled style={{ overflowY: 'hidden' }}>
            <ErrorBoundary>
              <ProjectConfigurationList
                handleClick={(item) => {
                  setConfigurationDetails(item);
                }}
              />
            </ErrorBoundary>
            <ErrorBoundary>
              {configurationDetails && (
                <ProjectConfigurationDetails
                  configurationData={configurationDetails}
                  onItemDelete={() => {
                    setConfigurationDetails(null);
                  }}
                />
              )}
              {!configurationDetails && (
                <Box
                  alignItems={{ sm: 'center' }}
                  justifyContent={{ sm: 'center' }}
                  css={{ position: 'relative', width: '100%', height: '98%' }}
                >
                  <Text size="600" color="grey.500">
                    Please select an item to edit
                  </Text>
                </Box>
              )}
            </ErrorBoundary>
          </ProjectAdminSubContainerStyled>
        </ErrorBoundary>
      ) : (
        <UnderConstruction></UnderConstruction>
      )}
    </ProjectAdminContainer>
  );
};
